import { AxiosUtilsType, axiosGet, axiosPut } from './axiosUtils';
import './axiosInterceptor';

const NotificationService = {
  async getNotification(last?: string): AxiosUtilsType {
    let url = 'notification';
    if (last) {
      url += `?last=${last}`;
    }
    return await axiosGet(url);
  },

  async putReadMessage(recId: number): AxiosUtilsType {
    return await axiosPut(`notification/${recId}`);
  },
};
export default NotificationService;
